var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useEffect, useCallback } from 'react';
import useReducedMotion from './useReducedMotion';
function Collapse(_a) {
    var { style, isOpen, duration = 150, easing = 'ease-in-out' } = _a, rest = __rest(_a, ["style", "isOpen", "duration", "easing"]);
    const prefersReducedMotion = useReducedMotion();
    const containerRef = useRef(null);
    const [isMounted, setIsMounted] = useState(isOpen);
    const [height, setHeight] = useState(() => (isOpen ? 'auto' : '0'));
    const [overflow, setOverflow] = useState(() => isOpen ? 'visible' : 'hidden');
    useEffect(() => {
        if (prefersReducedMotion) {
            setIsMounted(isOpen);
            return;
        }
        if (isOpen && !isMounted) {
            setIsMounted(true);
            return;
        }
        if (isMounted && containerRef.current) {
            const willExpand = isOpen && height !== 'auto';
            const willCollapse = !isOpen && height !== '0';
            if (willExpand) {
                setHeight(`${containerRef.current.scrollHeight}px`);
            }
            else if (willCollapse) {
                setHeight(`${containerRef.current.scrollHeight}px`);
                window.requestAnimationFrame(() => setTimeout(() => {
                    setHeight('0');
                    setOverflow('hidden');
                }));
            }
        }
    }, [isOpen, height, isMounted, prefersReducedMotion]);
    const onTransitionEnd = useCallback((e) => {
        if (e.target === containerRef.current && e.propertyName === 'height') {
            if (isOpen) {
                setHeight('auto');
                setOverflow('visible');
            }
            else {
                setIsMounted(false);
            }
        }
    }, [isOpen]);
    return isMounted ? (React.createElement("section", Object.assign({}, rest, { ref: containerRef, style: Object.assign(Object.assign({}, style), { willChange: prefersReducedMotion ? undefined : 'height', transition: prefersReducedMotion
                ? 'none'
                : `height ${duration}ms ${easing}`, height: prefersReducedMotion ? 'auto' : height, overflow: prefersReducedMotion ? 'visible' : overflow }), onTransitionEnd: onTransitionEnd }))) : null;
}
export default Collapse;
